import { cleanDoubleSlashes } from '@nx/populate-url'
import { seoName } from '@nx/seo-name'

import { domainBuilder } from '../domainBuilder/domainBuilder'

export function buildLocationPath(
  locationCode: string,
  locationName: string,
  domain?: string
) {
  const seoFriendlyName = seoName(locationName)

  let path = `/location/${locationCode}/${seoFriendlyName}/`
  if (domain) {
    path = domainBuilder(domain, path)
  }

  return cleanDoubleSlashes(path)
}
